import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatListItem, MatListItemLine, MatListItemTitle, MatNavList } from '@angular/material/list';
import { orderBy } from 'lodash-es';
import { Subscription } from 'rxjs';
import { CaseFormDialogComponent } from '../../features/case/form/dialog.component';
import { RepeatableCase } from '../../features/case/repeatable-case.model';
import { AgreementRestService } from '../../features/object/project/agreement/agreement-rest.service';
import { Case, Contractor } from '../../models/case';
import { DaterModule } from '../../pipes/dater/dater.module';
import { TranslateModule } from '../translate/translate.module';

@Component({
  selector: 'apex-repeatable-case-list-new',
  templateUrl: './repeatable-case-list-new.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatNavList,
    MatListItem,
    MatListItemTitle,
    MatListItemLine,
    MatDivider,
    TranslateModule,
    DaterModule,
  ],
  providers: [AgreementRestService],
})
export class RepeatableCaseListNewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() agreementId = 0;

  loading = false;
  repeatableCases: RepeatableCase[] = [];

  private subscription: Subscription = new Subscription();

  constructor(
    private dialog: MatDialog,
    private agreementRestService: AgreementRestService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['agreementId'] && this.agreementId > 0) {
      void this.fetchRepeatableCases();
    }
  }

  async fetchRepeatableCases(): Promise<void> {
    this.loading = true;

    try {
      const agreement = await this.agreementRestService.read(this.agreementId);

      this.repeatableCases = orderBy(
        agreement.RepeatableCases?.map((rc) => new RepeatableCase(rc as unknown as Partial<RepeatableCase>)) || [],
        ['endDate'],
        'asc',
      );
    } catch (error) {
      console.error('Error fetching repeatable cases:', error);
      this.repeatableCases = [];
    } finally {
      this.loading = false;
    }
  }

  ngOnInit(): void {
    if (this.agreementId > 0) {
      void this.fetchRepeatableCases();
    }
  }

  click(rc: RepeatableCase): void {
    rc.case.Contractors = rc?.RepeatableCaseContractors?.map((rcc) => {
      const contractor = new Contractor(rcc);

      return contractor;
    });

    const rcCase: Case = {
      ...rc.case,
      RepeatableCase: rc,
    };

    const ref = this.dialog.open(CaseFormDialogComponent, {
      data: {
        case: rcCase,
      },
    });

    // @TODO nasty hack, do more bettery
    setTimeout(() => {
      ref.componentInstance.formComponent.createRepeatableCase = true;
    });

    this.subscription.add(
      ref.afterClosed().subscribe(() => {
        void this.fetchRepeatableCases();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
